export const COPILOT_PANEL_WIDTH_KEY = "pw-copilot-width";
export const COPILOT_PANEL_MIN_WIDTH = 380;
export const COPILOT_PANEL_MAX_WIDTH = 640;
export const COPILOT_PANEL_DEFAULT_WIDTH = 460;

export type CopilotWidthStorage = Pick<Storage, "getItem" | "setItem">;

export function clampCopilotPanelWidth(width: number): number {
  if (!Number.isFinite(width)) return COPILOT_PANEL_DEFAULT_WIDTH;
  return Math.min(COPILOT_PANEL_MAX_WIDTH, Math.max(COPILOT_PANEL_MIN_WIDTH, Math.round(width)));
}

export function readCopilotPanelWidth(storage?: CopilotWidthStorage): number {
  try {
    const source = storage ?? (typeof window === "undefined" ? undefined : window.localStorage);
    if (!source) return COPILOT_PANEL_DEFAULT_WIDTH;
    const raw = source.getItem(COPILOT_PANEL_WIDTH_KEY);
    if (raw === null || raw.trim() === "") return COPILOT_PANEL_DEFAULT_WIDTH;
    const width = Number(raw);
    return Number.isFinite(width) ? clampCopilotPanelWidth(width) : COPILOT_PANEL_DEFAULT_WIDTH;
  } catch {
    return COPILOT_PANEL_DEFAULT_WIDTH;
  }
}

export function writeCopilotPanelWidth(width: number, storage?: CopilotWidthStorage): boolean {
  try {
    const destination =
      storage ?? (typeof window === "undefined" ? undefined : window.localStorage);
    if (!destination) return false;
    destination.setItem(COPILOT_PANEL_WIDTH_KEY, String(clampCopilotPanelWidth(width)));
    return true;
  } catch {
    return false;
  }
}
